import React from 'react';

import Footer from 'Components/Footer';
import GoogleReviews from 'Components/GoogleReviews';
import Header from 'Components/Header';
import WorkerReviews from 'Components/WorkerReviews';

export default function Reviews() {
  return (
    <>
      <Header />
      <WorkerReviews bg='bg' overlay='dark' />
      <GoogleReviews bg='black__bgr' overlay='dark' />
      <Footer />
    </>
  );
}
